import React from "react";
import { resolveFaqVideo } from "./faqMediaUtils";

function looksLikeHtml(value) {
  return /<\/?[a-z][\s\S]*>/i.test(String(value || ""));
}

export default function FaqAnswerContent({ faq, onPlayVideo }) {
  const { embedUrl, shareUrl, displayAnswer } = resolveFaqVideo(faq);
  // Prefer HTML render whenever markup is present so editor changes show as-is.
  const htmlAnswer = looksLikeHtml(displayAnswer || faq?.answer);

  return (
    <>
      {htmlAnswer ? (
        <div
          className="faq-answer-html ql-editor"
          dangerouslySetInnerHTML={{ __html: displayAnswer || "" }}
        />
      ) : (
        <p>{displayAnswer}</p>
      )}
      {embedUrl ? (
        <div className="faq-item-actions">
          <button
            type="button"
            className="faq-video-button"
            onClick={() =>
              onPlayVideo({
                embedUrl,
                shareUrl,
                title: faq.question,
              })
            }
          >
            <i className="fas fa-play-circle" aria-hidden="true" />
            Watch guide video
          </button>
        </div>
      ) : null}
      {faq.hasGuide ? (
        <div className="faq-item-actions">
          <button type="button" className="faq-link-button">
            View Guide <i className="fas fa-external-link-alt" />
          </button>
        </div>
      ) : null}
    </>
  );
}
